import type { DataFetchParams } from '@/components/DataTable';
import { FilterOperators } from '@kirin/api-client/contracts/table';
import { MCP_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/mcp';

export type MCPSourceFilterValue = 'gateway' | 'endpoint' | null;

/**
 * Same key MCP_FILTER_URL_KEYS uses for the provenance field, kept in sync
 * via the `satisfies Record<MCPFilterableField, string>` exhaustiveness check
 * in constants.ts. Not routed through DataTable's own column-filter/URL
 * encoding — this is a bespoke control (3 buttons, not a column), so it owns
 * its URL param directly.
 */
export const MCP_SOURCE_FILTER_URL_PARAM = 'pr';

export function readSourceFilterFromUrl(
  searchParams: URLSearchParams
): MCPSourceFilterValue {
  const raw = searchParams.get(MCP_SOURCE_FILTER_URL_PARAM);
  return raw === 'gateway' || raw === 'endpoint' ? raw : null;
}

/**
 * Inject (or clear) the provenance filter into DataTable query params. `null`
 * ("All sources") returns `params` unchanged (identity) so callers can rely
 * on referential equality to skip re-fetching when nothing changed.
 */
export function applySourceFilter(
  params: DataFetchParams,
  source: MCPSourceFilterValue
): DataFetchParams {
  if (!source) return params;
  return {
    ...params,
    filters: [
      ...params.filters.filter(
        f => f.field !== MCP_FILTERABLE_FIELDS.PROVENANCE
      ),
      {
        field: MCP_FILTERABLE_FIELDS.PROVENANCE,
        operator: FilterOperators.INCLUDES,
        value: [source],
      },
    ],
  };
}
